"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonceProvider = void 0;
Object.defineProperty(exports, "components", {
  enumerable: true,
  get: function get() {
    return _chunk80640036BrowserEsm.y;
  }
});
Object.defineProperty(exports, "createFilter", {
  enumerable: true,
  get: function get() {
    return _reactSelectCac0a5aeBrowserEsm.c;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "defaultTheme", {
  enumerable: true,
  get: function get() {
    return _reactSelectCac0a5aeBrowserEsm.a;
  }
});
Object.defineProperty(exports, "mergeStyles", {
  enumerable: true,
  get: function get() {
    return _reactSelectCac0a5aeBrowserEsm.m;
  }
});

require("@babel/runtime/helpers/esm/objectWithoutProperties");

require("@babel/runtime/helpers/esm/extends");

require("@babel/runtime/helpers/esm/toConsumableArray");

require("@babel/runtime/helpers/esm/objectSpread");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _core = require("@emotion/core");

require("react-dom");

require("@babel/runtime/helpers/esm/typeof");

require("./chunk-39d3fda8.browser.esm.js");

var _chunk80640036BrowserEsm = require("./chunk-80640036.browser.esm.js");

var _reactSelectCac0a5aeBrowserEsm = require("./base/dist/react-select-cac0a5ae.browser.esm.js");

require("@emotion/css");

require("@babel/runtime/helpers/esm/taggedTemplateLiteral");

require("react-input-autosize");

var _chunkB36baf1aBrowserEsm = require("./chunk-b36baf1a.browser.esm.js");

var _cache = _interopRequireDefault(require("@emotion/cache"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof2(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NonceProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NonceProvider, _Component);

  function NonceProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NonceProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NonceProvider).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "createEmotionCache", function (nonce) {
      return (0, _cache.default)({
        nonce: nonce
      });
    });
    _this.createEmotionCache = (0, _memoizeOne.default)(_this.createEmotionCache);
    return _this;
  }

  (0, _createClass2.default)(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce);
      return /*#__PURE__*/_react.default.createElement(_core.CacheProvider, {
        value: emotionCache
      }, this.props.children);
    }
  }]);
  return NonceProvider;
}(_react.Component);

exports.NonceProvider = NonceProvider;
var index = (0, _chunkB36baf1aBrowserEsm.m)(_reactSelectCac0a5aeBrowserEsm.S);
var _default = index;
exports.default = _default;